/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SearchResources200ResponseTablesInnerTablesInnerColumnsInner } from '../models/SearchResources200ResponseTablesInnerTablesInnerColumnsInner';

export class SearchResources200ResponseTablesInnerTablesInner {
  'name'?: string;
  'schemaName'?: string;
  'databaseName'?: string;
  'rowsCount'?: number;
  'columns'?: Array<SearchResources200ResponseTablesInnerTablesInnerColumnsInner>;
  'explanation'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "schemaName",
      "baseName": "schemaName",
      "type": "string",
      "format": ""
    },
    {
      "name": "databaseName",
      "baseName": "databaseName",
      "type": "string",
      "format": ""
    },
    {
      "name": "rowsCount",
      "baseName": "rowsCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "columns",
      "baseName": "columns",
      "type": "Array<SearchResources200ResponseTablesInnerTablesInnerColumnsInner>",
      "format": ""
    },
    {
      "name": "explanation",
      "baseName": "explanation",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SearchResources200ResponseTablesInnerTablesInner.attributeTypeMap;
  }

  public constructor() {
  }
}

